import '../reset.css';
import '../style.css';
import '../styles/careers.css';
import {userBrowserId} from '../scripts/common.js';
import {initIframeResize} from './_inIFrame.js';

initIframeResize();
